import { Typography, TypographyProps, styled } from "@mui/material";

const SmallTypography = styled(Typography)<TypographyProps>(({ theme }) => ({
  color: "#6E6969",
  fontSize: '0.6rem',
  fontWeight: 600
}));

export default SmallTypography;       